import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar } = FiIcons;

const testimonials = [
  {
    quote: "Padua is pure magic. The architecture and the way the light hits the courtyard is something we haven't found anywhere else.",
    author: "Elena & Marcus"
  },
  {
    quote: "The hospitality at the estate is unmatched. Our tour felt like a conversation with friends who truly cared about our vision.",
    author: "Sarah & David"
  },
  {
    quote: "Stunning, historic, and romantic. It's the perfect canvas for a wedding that feels both timeless and personal.",
    author: "Jessica & Michael"
  }
];

export default function SocialProof() {
  return (
    <section className="bg-aged-ivory py-20 md:py-32 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex-1"
          >
            <span className="font-sans text-[10px] md:text-xs uppercase tracking-[0.4em] text-estate-gold block mb-4">
              Legacy of Romance
            </span>
            <h2 className="font-serif text-3xl md:text-5xl text-burgundy mb-6 leading-tight">
              A Venue Couples Remember
            </h2>
            <p className="font-sans font-light text-charcoal/70 text-base md:text-lg leading-relaxed mb-10">
              Padua Weddings has welcomed generations of celebrations throughout its Spanish Revival estate in the Claremont foothills.
            </p>

            <div className="flex items-center gap-2 mb-8">
              {[1, 2, 3, 4, 5].map((s) => (
                <SafeIcon key={s} icon={FiStar} className="text-floral-marigold text-lg fill-current" />
              ))}
              <span className="font-sans text-xs md:text-sm text-charcoal/50 ml-2 tracking-wide uppercase">
                Verified 5-Star Experience
              </span>
            </div>

            <div className="space-y-8">
              {testimonials.map((t, i) => (
                <div key={i} className="border-l border-estate-gold/30 pl-6">
                  <p className="font-serif italic text-lg text-burgundy/80 mb-2 leading-relaxed">
                    “{t.quote}”
                  </p>
                  <span className="font-sans text-[10px] uppercase tracking-widest text-charcoal/40">
                    — {t.author}
                  </span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex-1 w-full"
          >
            <div className="relative">
              <div className="absolute -inset-4 border border-estate-gold/20 -z-10 translate-x-4 translate-y-4"></div>
              <img 
                src="https://images.unsplash.com/photo-1549416878-b9ca35c2d47b?q=80&w=2070&auto=format&fit=crop" 
                alt="Wedding at Padua Estate" 
                className="w-full h-auto object-cover invitation-shadow rounded-sm"
              />
              <div className="absolute bottom-6 right-6 bg-white/90 backdrop-blur-sm p-4 border border-estate-gold/10 hidden md:block">
                <p className="font-sans text-[10px] uppercase tracking-widest text-burgundy mb-2">
                  Featured On
                </p>
                <div className="flex gap-4 opacity-40 grayscale">
                   {/* Placeholder Logos */}
                   <div className="w-12 h-6 bg-charcoal/20"></div>
                   <div className="w-12 h-6 bg-charcoal/20"></div>
                   <div className="w-12 h-6 bg-charcoal/20"></div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}